import { makeApiUrl, makeAxiosHttpClient } from "../../../main/factories/http";
import { RemoteAuthentication } from "../../../data/usecases";
import { Authentication } from "../../../domain/usecases";
import { makeAuthorizeHttpClientDecorator } from "../decorators";

export const makeRemoteAuthentication = (): Authentication =>
  new RemoteAuthentication(
    makeApiUrl("/login"),
    makeAuthorizeHttpClientDecorator()
  );
